import AirportInput from "../../AirportInput";
import { changeDestinationAirport, changeOriginAirport } from "../../../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { useTranslation } from "react-i18next";

function AirportInputSFO() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const direction = useAppSelector(
    (state) => state.searchFlights.form.direction
  );
  const destinationAirport = useAppSelector(
    (state) => state.searchFlights.form.destinationAirport
  );
  
  const originAirport = useAppSelector(
    (state) => state.searchFlights.form.originAirport
  )
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const destValidity = useAppSelector(
    (state) => state.searchFlights.formValidity.destinationAirport
  );

  const originValidity = useAppSelector(
    (state) => state.searchFlights.formValidity.originAirport
  );
  const onSelect = (suggestion) => {
    if (direction === "from") {
      dispatch(changeDestinationAirport(suggestion));
    } else {
      dispatch(changeOriginAirport(suggestion));
    }
  };

  return (
    <div className="column pl-0 is-one-third airport-div">
      <AirportInput
        id="destination-airport-input"
        airport={direction === "from" ? destinationAirport: originAirport }
        validity={direction === "from" ? destValidity: originValidity}
        validityMessage={direction === "from" ? t("SEARCH_ALERT_DESTINATION_AIRPORT") : t("SEARCH_ALERT_ORIGIN_AIRPORT")}
        icon={faSearch}
        label={direction === 'from' ? t("SFO_INPUT_LABEL_TO") : t("SFO_INPUT_LABEL_FROM")}
        placeholder={direction === 'from' ? `${t("INPUT_SELECT_ARRIVAL_AIRPORT")}` : `${t("INPUT_SELECT_DEPARTURE_AIRPORT")}`}
        title={direction === 'from' ? t("DESTINATION_SEARCH_TITLE") : t("ORIGIN_SEARCH_TITLE")}
        onSelect={onSelect}
        disabled={disabled}
      />
    </div>
  );
}

export default AirportInputSFO;
